var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6E6259",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.7 0 0 4.7 0 10.5 0 16.3 4.7 21 10.5 21 16.298 21 21 16.299 21 10.5 21 4.7 16.298 0 10.5 0zm0 19.287c-4.856 0-8.789-3.933-8.789-8.787 0-4.855 3.933-8.79 8.79-8.79 4.851 0 8.787 3.936 8.787 8.79 0 4.854-3.936 8.787-8.788 8.787z",
    transform: "translate(-20 -766) translate(20 766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.05 8L9.147 8 9.147 8.004 8.066 8.004 8.066 9.449 9.147 9.449 9.147 14.61 8 14.61 8 15.99 9.147 15.99 9.147 16 12.05 16 12.05 15.99 13 15.99 13 14.61 12.05 14.61zM10.471 7C11.423 7 12 6.329 12 5.498 11.982 4.651 11.423 4 10.51 4S9 4.65 9 5.498C9 6.33 9.577 7 10.471 7z",
    transform: "translate(-20 -766) translate(20 766)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmb);
export default __webpack_public_path__ + "static/media/amb.f4362a63.svg";
export { ForwardRef as ReactComponent };